import { Box } from "@mui/material";

export const Unauthorized = () =>
    <Box>
      <h1>Unauthorized</h1>
    </Box>